import BroadcastThumbnail from './BroadcastThumbnail';

export default BroadcastThumbnail;
